import * as React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import {
  FlightGroupModel,
  FlightDotModel,
  FlightConnectionsModel
} from '../../../../../const/FlightModel';
import './FlightConnections.css';

const CONNECTION_MAX_OFFSET = 2;
const CONNECTION_SHOW_NUMBER = 4;
let connectionsArray = [];

const propTypes = {
  flightGroup: PropTypes.any,
  isDepartureFlight: PropTypes.any
};

class FlightConnections extends React.Component {
  componentWillMount() {
    connectionsArray = [];
    this.createConnectionsArray();
  }

  render() {
    return (
      <Row>
        <Col className="FlightConnections" span={24}>
          {this.renderConnections()}
        </Col>
      </Row>
    );
  }
  isConnectionDot(index) {
    return index <= CONNECTION_MAX_OFFSET;
  }

  isConnectionPlusInformation(index, flightLength) {
    return index === CONNECTION_MAX_OFFSET && flightLength >= CONNECTION_SHOW_NUMBER;
  }

  createConnectionsArray() {
    Object.freeze(this.props.flightGroup);
    const groups = Object.assign([], this.props.flightGroup);
    const plus = new FlightDotModel(false, 0);
    connectionsArray = [];

    if (groups.length > 1) {
      groups.splice(0, 1);
      const flightsLength = groups.length;

      groups.forEach((flight, index) => {
        if (this.isConnectionDot(index)) {
          if (this.isConnectionPlusInformation(index, flightsLength)) {
            plus.isRed = flight.hasExchangeAirport;
            plus.value = flightsLength - connectionsArray.length;
          } else {
            this.pushToFlightGroups(flight, true, null);
          }
        } else {
          plus.isRed = plus.isRed !== true ? flight.hasExchangeAirport : plus.isRed;
        }
      });
      this.createConnectionNumber(flightsLength, plus);
    }
  }

  pushToFlightGroups(flight, isDot, numberInfo) {
    connectionsArray.push(
      new FlightConnectionsModel(
        flight.flightNumber.toString(),
        numberInfo,
        isDot,
        flight.hasExchangeAirport
      )
    );
  }

  createConnectionNumber(groupLength, plus) {
    if (groupLength >= CONNECTION_SHOW_NUMBER) {
      this.pushToFlightGroups(new FlightGroupModel(0, plus.isRed), false, plus.value);
    }
  }

  renderConnections() {
    if (connectionsArray.length > 0) {
      return connectionsArray.map(group => {
        const connectionShape = group.dot
          ? 'FlightConnections__dotsContainer__dot'
          : 'FlightConnections__dotsContainer__plus';
        const connectionClasses =
          connectionShape + (group.isRed ? ' ' + connectionShape + '--red' : '');
        return (
          <div
            id={`${this.props.isDepartureFlight ? 'departure-' : 'arrival-'}plus-${group.id}`}
            key={`plus-${group.id}`}
            className={'FlightConnections__dotsContainer'}>
            <div className={connectionClasses}>
              {group.numberInfo ? '+' + group.numberInfo : ''}
            </div>
          </div>
        );
      });
    }
  }
}

FlightConnections.propTypes = propTypes;

export default FlightConnections;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/components/flightInfoTime/flightConnections/FlightConnections.jsx